import "./FileDragAndDropComponent.scss";

import React, {useCallback} from 'react';
import {useDropzone} from "react-dropzone";
import {CloudUpload} from "@mui/icons-material";
import ButtonComponent from "../core/button/ButtonComponent"
interface FileDragAndDropComponentProps {
    title?: string;
    onFilesDrop?: Function;
    acceptedFileTypes?: any;
    multiple?: boolean;
    maxFiles?: number;
    fileSizeLimitText?: string;
}

const FileDragAndDropComponent = (props: FileDragAndDropComponentProps) => {

    const { title, onFilesDrop, acceptedFileTypes, multiple,maxFiles ,fileSizeLimitText} = props;

    const onDrop = useCallback((acceptedFiles: any) => {
        acceptedFiles.forEach((file: any) => {
            const reader = new FileReader();
            reader.onabort = () => console.log('file reading was aborted')
            reader.onerror = () => console.log('file reading has failed')
            reader.onload = () => {
                // Do whatever you want with the file contents
                //const binaryStr = reader.result;
            }
            reader.readAsArrayBuffer(file)
        });
        if (onFilesDrop){
            onFilesDrop(acceptedFiles);
        }
    }, [onFilesDrop]);

    const {getRootProps, getInputProps} = useDropzone({onDrop, accept: acceptedFileTypes, multiple: multiple,maxFiles:maxFiles});

    return (
        <div className="file-dnd-wrapper" {...getRootProps()}>
            <input {...getInputProps()}/>
            <div className="file-dnd-icon-sub-title">
                <div className="file-dnd-icon">
                    <CloudUpload/>
                </div>
                { title && <div className="file-dnd-sub-title">
                    {title}
                </div> }
            </div>
            {
                fileSizeLimitText && <div className="file-dnd-dnd-title">
                    {fileSizeLimitText}
                </div>
            }
            <div className="file-dnd-choose-file-button">
                <ButtonComponent variant={"outlined"}
                                 color={"secondary"} >
                    Choose file
                </ButtonComponent>
            </div>
        </div>
    )
};

export default FileDragAndDropComponent;


//EXAMPLE START

// <FileDragAndDropComponent onFilesDrop={handleResultFilesDrop}
//                           acceptedFileTypes={{
//                               'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': []
//                           }}/>

//EXAMPLE END
